import { useEffect, useState } from "react";
import api, { imgUrl } from "@/lib/api";
import SEOHead from "@/components/SEOHead";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then(({ data }) => setItems(data)); }, []);

  return (
    <div data-testid="gallery-page" className="bg-[var(--pz-ink)] text-white">
      <SEOHead title="Gallery — The Arena" description="Photos from matches, tournaments and floodlit nights at the arena." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-xs uppercase tracking-[0.35em] text-[var(--pz-red)] font-bold mb-4">Moments</div>
        <h1 className="font-display text-5xl md:text-7xl font-bold uppercase leading-none">Gallery</h1>
        <p className="mt-6 text-zinc-400 max-w-2xl">A look back at the floodlit nights, the close finishes and the trophies lifted.</p>

        <div className="mt-14 columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
          {items.map((g, i) => (
            <img
              key={g.id}
              src={imgUrl(g.image_url)}
              alt={g.title}
              data-testid={`gallery-item-${i}`}
              className="mb-4 w-full rounded-md hover:opacity-80 hover:scale-[1.01] transition-all pz-fade-up"
              style={{ animationDelay: `${i * 40}ms` }}
            />
          ))}
          {items.length === 0 && <div className="text-zinc-500">No photos yet.</div>}
        </div>
      </div>
    </div>
  );
}
